import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LedgerRoutingModule } from './ledger-routing.module';
import { ManageRewardsComponent } from './manage-rewards/manage-rewards.component';
import { ManageExpertsRewardsComponent } from './manage-experts-rewards/manage-experts-rewards.component';
import { SessionRewardsComponent } from './session-rewards/session-rewards.component';
import { SharedModule } from '../../shared/shared.module';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';

@NgModule({
  declarations: [
    ManageRewardsComponent,
    ManageExpertsRewardsComponent,
    SessionRewardsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    LedgerRoutingModule,
    SharedModule,
    NzTableModule,
    NzSpinModule,
    NzGridModule,
    NzInputModule,
    NzButtonModule,
  ],
})
export class LedgerModule {}
